var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.normal)?_c('Button',{staticClass:"inline",staticStyle:{"margin-right":"auto"},attrs:{"label":"Back","icon":"left-arrow"}}):_c('CoolButton',{staticClass:"back-button",attrs:{"label":"Back","type":"compact","animation":"infinite","icon":"back-arrow","textColor":"#ffdc82","bgColor":"rgb(244,186,75)","touchClass":"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }